import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { RouterLink } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RDMCredentialsInfo',
    props: {
        selectedRepository: { default: undefined },
        isPrivateFileSource: { type: Boolean, default: undefined }
    },
    setup(__props) {
        const props = __props;
        const repositoryName = props.selectedRepository?.label ?? "the selected repository";
        return { __sfc: true, props, repositoryName, BAlert, RouterLink };
    }
});
